/**
 * Public-launch gate (2026-08-31).
 *
 * The marketing landing page and the open-signup funnel are DEPLOYED but kept
 * out of public view until go-live — the same "ship dark, flip at launch"
 * posture as the billing checkout gate and `Enrollment:InviteRequired`. When
 * the funnel is dark, the anonymous root serves a minimal HoldingPage and no
 * page advertises self-serve signup.
 *
 * Default is ON: dev, tests, and e2e see the full funnel (the shipped product).
 * It is turned OFF only by an EXPLICIT `VITE_PUBLIC_LANDING=false` build arg —
 * which the pre-launch PROD build sets (weekly-release → web-app Dockerfile).
 * Remove that build arg (or set it "true") at go-live to reveal the landing
 * page. Existing/authed accounts are never affected; this only governs what an
 * anonymous, pre-launch visitor is shown.
 */
export const PUBLIC_LANDING_ENABLED =
  ((import.meta as unknown as { env?: Record<string, string | undefined> }).env
    ?.VITE_PUBLIC_LANDING) !== 'false';
